import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {ApiService} from '../../../api.service';

@Component({
  selector: 'app-company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.css']
})
export class CompanyComponent implements OnInit {

  Company: {} = [];

  constructor(
    public restApi: ApiService
  ) { }

  @Output()
  selectedCompanyID: EventEmitter<number> = new EventEmitter<number>();

  ngOnInit() {
    this.loadCompany();
  }

  // Get employees list
  loadCompany() {
    return this.restApi.getCompany().subscribe((data: {}) => {
      this.Company = data;
    });
  }

  onChange(message) {
    this.selectedCompanyID.emit(message);
  }
}
